import { isBrandRefreshEnabled } from '../../../shared/utilities/brandRefresh';

export const isBoxSleeveBrandRefresh = () => isBrandRefreshEnabled();

export const getGiftBoxRegionProps = () =>
  isBrandRefreshEnabled() ? { 'data-region': 'gift-box-options' } : {};

export const getGiftBoxPartProps = part =>
  isBrandRefreshEnabled() ? { 'data-part': part } : {};

export const getBackIcon = (legacyIcon, brandRefreshIcon) =>
  isBrandRefreshEnabled() ? brandRefreshIcon : legacyIcon;

export const getRadioIcons = (brandRefreshOffIcon, brandRefreshOnIcon) =>
  isBrandRefreshEnabled()
    ? { off: brandRefreshOffIcon, on: brandRefreshOnIcon }
    : null;
